const noop = function () { }

const merge = function (a, b) {
  a || (a = {})
  b || (b = {})
  for (let k in b) {
    a[k] = b[k]
  }
  return a
}

class Recorder {
  constructor (set) {
    this.set = merge({
      type: 'wav',
      // 比特率 wav:16或8位，MP3：8比特1k/s，16比特2k/s 比较划得来
      bitRate: 16,
      // 采样率，wav专用；wav格式大小=sampleRate*时间；mp3此项无效，对文件大小无影响，直接使用源采样率
      // 采样率参考https://www.cnblogs.com/devin87/p/mp3-recorder.html
      sampleRate: 16000,
      // AudioContext缓冲大小，相对于ctx.sampleRate=48000/秒：
      // 取值256, 512, 1024, 2048, 4096, 8192, or 16384，会影响onProcess调用速度
      bufferSize: 8192,
      // fn(this.buffer,powerLevel,bufferDuration) buffer=[缓冲数据,...]，powerLevel：当前缓冲的音量级别0-100，bufferDuration：已缓冲时长
      onProcess: noop
    }, set)
  }

  // 打开录音资源True(),False(msg)，需要调用close。注意：此方法是异步的；一般使用时打开，用完立即关闭；可重复调用，可用来测试是否能录音
  open (True, False) {
    True = True || noop
    False = False || noop

    if (Recorder.IsOpen()) {
      True()
      return
    }

    let notSupport = '此浏览器不支持录音'
    let AC = window.AudioContext
    if (!AC) {
      AC = window.webkitAudioContext
    }
    if (!AC) {
      False(notSupport)
      return
    }

    let scope = navigator.mediaDevices || {}
    if (!scope.getUserMedia) {
      scope = navigator
      scope.getUserMedia ||
        (scope.getUserMedia =
          scope.webkitGetUserMedia ||
          scope.mozGetUserMedia ||
          scope.msGetUserMedia)
    }
    if (!scope.getUserMedia) {
      False(notSupport)
      return
    }

    // 不能反复构造，number of hardware contexts reached maximum (6)
    Recorder.Ctx = Recorder.Ctx || new AC()
    let f1 = function (stream) {
      Recorder.Stream = stream
      True()
    }
    let f2 = function (e) {
      let code = e.code || e.name || ''
      False(
        /Permission/i.test(code) ? '用户拒绝了录音权限' : '无法录音：' + code
      )
    }
    let pro = scope.getUserMedia({
      audio: true
    }, f1, f2
    )
    if (pro && pro.then) {
      pro.then(f1).catch(f2)
    }
  }

  // 关闭释放录音资源
  close (call) {
    call = call || noop

    let This = this
    This._stop()

    let stream = Recorder.Stream
    if (stream) {
      let tracks = stream.getTracks()
      for (let i = 0; i < tracks.length; i++) {
        tracks[i].stop()
      }
    }

    Recorder.Stream = 0
    call()
  }

  // 开始录音，需先调用open；不支持、错误，不会有任何提示，stop时自然能得到错误
  start () {
    console.log('[' + Date.now() + ']Start')
    let This = this
    let set = This.set
    let buffer = (This.buffer = []) // 数据缓冲
    This.recSize = 0 // 数据大小
    This._stop()

    This.state = 0
    if (!Recorder.IsOpen()) {
      return
    }

    let ctx = Recorder.Ctx
    let media = (This.media = ctx.createMediaStreamSource(Recorder.Stream))
    let process = (This.process = (
      ctx.createScriptProcessor || ctx.createJavaScriptNode
    ).call(ctx, set.bufferSize, 1, 1)) // 单声道，省的数据处理复杂

    let onInt
    process.onaudioprocess = function (e) {
      if (This.state !== 1) {
        return
      }
      let o = e.inputBuffer.getChannelData(0) // 块是共享的，必须复制出来
      let size = o.length
      This.recSize += size

      let res = new Int16Array(size)
      let power = 0
      for (let j = 0; j < size; j++) {
        // floatTo16BitPCM
        // let s=Math.max(-1,Math.min(1,o[j]*8));//PCM 音量直接放大8倍，失真还能接受
        let s = Math.max(-1, Math.min(1, o[j]))
        s = s < 0 ? s * 0x8000 : s * 0x7fff
        res[j] = s
        power += Math.abs(s)
      }
      buffer.push(res)

      power /= size
      let powerLevel = 0
      if (power > 0) {
        // https://blog.csdn.net/jody1989/article/details/73480259
        powerLevel = Math.round(
          Math.max(0, ((20 * Math.log10(power / 0x7fff) + 34) * 100) / 34)
        )
      }
      let duration = Math.round((This.recSize / Recorder.Ctx.sampleRate) * 1000)

      clearTimeout(onInt)
      onInt = setTimeout(function () {
        set.onProcess(buffer, powerLevel, duration)
      })
    }

    media.connect(process)
    process.connect(ctx.destination)
    This.state = 1
  }

  _stop () {
    let This = this
    if (This.state) {
      This.state = 0
      This.media.disconnect()
      This.process.disconnect()
    }
  }

  /* 暂停录音 */
  pause (_resume) {
    let This = this
    if (This.state) {
      This.state = _resume || 2
    }
  }

  /* 恢复录音 */
  resume () {
    this.pause(1)
  }

  /*
    结束录音并返回录音数据blob对象
    True(blob,duration) blob：录音数据audio/mp3|wav格式
    duration：录音时长，单位毫秒
    False(msg)
    */
  stop (True, False) {
    console.log('[' + Date.now() + ']Stop')
    True = True || noop
    False = False || noop
    let This = this
    let set = This.set

    if (!This.state) {
      False('未开始录音')
      return
    }
    This._stop()
    let size = This.recSize

    if (!size) {
      False('未采集到录音')
      return
    }

    // 准备数据
    let res = new Int16Array(size)
    let offset = 0
    for (let i = 0; i < This.buffer.length; i++) {
      let o = This.buffer[i]
      res.set(o, offset)
      offset += o.length
    }
    let duration = Math.round((size / Recorder.Ctx.sampleRate) * 1000)

    setTimeout(function () {
      let t1 = Date.now()
      This[set.type](res, function (blob) {
        console.log(
          '[' + Date.now() + ']End',
          blob,
          duration,
          '编码耗时:' + (Date.now() - t1)
        )
        True(blob, duration)
      })
    })
  }

  wav (res, call) {
    let This = this
    let set = This.set
    let size = This.recSize
    let sampleRate = set.sampleRate
    let ctxSampleRate = Recorder.Ctx.sampleRate
    let bitRate = set.bitRate === 8 ? 8 : 16

    // 采样 https://www.cnblogs.com/blqw/p/3782420.html
    let compression = Math.round(ctxSampleRate / sampleRate)
    if (compression > 1) {
      // 新采样高于录音采样不处理，省去了插值处理，直接抽样
      size = Math.floor(size / compression)
      let compRes = new Int16Array(size)
      let i = 0
      let j = 0
      while (i < size) {
        compRes[i] = res[j]
        j += compression
        i++
      }
      res = compRes
    } else {
      sampleRate = ctxSampleRate
    }

    // 编码数据 https://github.com/mattdiamond/Recorderjs https://www.cnblogs.com/blqw/p/3782420.html https://www.cnblogs.com/xiaoqi/p/6993912.html
    let dataLength = size * (bitRate / 8)
    let buffer = new ArrayBuffer(44 + dataLength)
    let data = new DataView(buffer)

    let offset = 0
    let writeString = function (str) {
      for (let i = 0; i < str.length; i++, offset++) {
        data.setUint8(offset, str.charCodeAt(i))
      }
    }
    let write16 = function (v) {
      data.setUint16(offset, v, true)
      offset += 2
    }
    let write32 = function (v) {
      data.setUint32(offset, v, true)
      offset += 4
    }

    /* RIFF identifier */
    writeString('RIFF')
    /* RIFF chunk length */
    write32(36 + dataLength)
    /* RIFF type */
    writeString('WAVE')
    /* format chunk identifier */
    writeString('fmt ')
    /* format chunk length */
    write32(16)
    /* sample format (raw) */
    write16(1)
    /* channel count */
    write16(1)
    /* sample rate */
    write32(sampleRate)
    /* byte rate (sample rate * block align) */
    write32(sampleRate * (bitRate / 8))
    /* block align (channel count * bytes per sample) */
    write16(bitRate / 8)
    /* bits per sample */
    write16(bitRate)
    /* data chunk identifier */
    writeString('data')
    /* data chunk length */
    write32(dataLength)
    // 写入采样数据
    if (bitRate === 8) {
      for (let i = 0; i < size; i++, offset++) {
        let val = res[i]
        val = parseInt(255 / (65535 / (val + 32768)))
        data.setInt8(offset, val, true)
      }
    } else {
      for (let i = 0; i < size; i++, offset += 2) {
        data.setInt16(offset, res[i], true)
      }
    }

    call(
      new Blob([data], {
        type: 'audio/mp3'
      })
    )
  }
}

Recorder.IsOpen = function () {
  let stream = Recorder.Stream

  if (stream) {
    let tracks = stream.getTracks()
    if (tracks.length > 0) {
      return tracks[0].readyState === 'live'
    }
  }

  return false
}

export default Recorder



// WEBPACK FOOTER //
// ./src/app/GenH5/recorder.js